import { useContext, useState } from "react"

import { Button, ErrorMessage, Field, Form, InfoMessage } from "web/components"
import { LocalizationContext } from "web/contexts"
import routes from "web/routes/constants"
import { useUnits } from "web/hooks/data"

import { sortByKey } from "web/services/helpers"

export default function NewPortfolio({ close, handleAddPortfolio }) {
  const [error, setError] = useState({
    message: undefined,
    isNameClash: false,
    id: undefined,
  })
  const [name, setName] = useState("")
  const NAME_CLASH_ERROR_TYPES = ["active_name_clash", "trashed_name_clash"]
  const [{ currencies }] = useUnits()
  const { defaultCurrency: defaultCurrencyCode } =
    useContext(LocalizationContext)

  const defaultCurrency = currencies.find((c) => c.code === defaultCurrencyCode)
  const formValue = {
    currency: {
      value: defaultCurrency.id,
      label: defaultCurrency.name,
    },
    name: {
      value: name,
    },
  }

  const formFields = [
    {
      key: "name",
      name: "name",
      kind: "Text",
      label: "Name",
      description: "Name of the portfolio.",
      required: true,
    },
    {
      key: "currency",
      name: "currency",
      kind: "Lookup",
      label: "Currency",
      required: true,
      lookup_values: sortByKey(
        currencies.map((c) => {
          return { value: c.code, label: c.name }
        }),
        "label"
      ),
    },
  ]

  async function handleSubmit({ name, currency }) {
    setName(name.value)
    setError({ message: undefined, isNameClash: false, id: undefined })
    try {
      await handleAddPortfolio({
        name: name.value,
        currency_code: currency && currency.value,
      })
      close()
    } catch (error) {
      const nameClashError = error.response.data.errors.find((er) =>
        NAME_CLASH_ERROR_TYPES.includes(er.type)
      )

      if (nameClashError) {
        setError({
          message: nameClashError.message,
          isNameClash: true,
          id: nameClashError.options.options.id,
        })
      } else {
        const e = error.response.data.errors[0]
        setError({ message: e.message, isNameClash: false, id: undefined })
      }
    }
  }

  function handleKeyUp(e) {
    const carriageReturn = 13

    if (e.which === carriageReturn) {
      handleSubmit()
    }
  }

  return (
    <Form
      value={formValue}
      onSubmit={handleSubmit}
      fields={formFields}
      render={(form) => {
        return (
          <div className="h-full">
            <div
              className="modal-content-above-commands space-y-3"
              onKeyUp={handleKeyUp}
            >
              <Field fieldKey="name" autoFocus={true} />
              <Field fieldKey="currency" />
              {error.isNameClash && (
                <InfoMessage title="Duplicate Name">
                  <p className="mb-2">{error.message}</p>
                  <p>
                    <a
                      href={routes.portfolio("all", null, error.id)}
                      onClick={close}
                      className="text-primary-4"
                      data-turbo-frame="_top"
                    >
                      View Portfolio
                    </a>
                  </p>
                </InfoMessage>
              )}
              {error.message && !error.isNameClash && (
                <ErrorMessage message={error.message} />
              )}
            </div>
            <div className="modal-commands">
              <div className="right-buttons">
                <Button
                  onClick={form.submit}
                  disabled={!form.isValid}
                  disableAfterClick
                >
                  Create Portfolio
                </Button>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}
